<script setup lang="ts">
const props = defineProps<{
  theme: string | null | undefined
  data: {
    media?: unknown
    placement?: string
    showVideoControls?: boolean
    isArticle?: boolean
    containFullImage?: boolean
  }
}>()

const placementWrapperStyles = computed(() => {
  return {
    full:
      'w-full ' + `${props.data?.containFullImage ? '' : 'lg:h-screen aspect-3/4 lg:aspect-auto'}`,
    left: 'px-bleed flex flex-row-reverse gap-bleed rounded-sm',
    right: 'px-bleed flex flex-row gap-bleed rounded-sm',
    center: 'px-bleed w-full',
  }
})
const placementMediaStyles = computed(() => {
  return {
    full: 'h-full w-full',
    left:
      'w-full shrink-0 lg:w-cols-6 h-fit rounded-sm ' +
      `${props.data?.containFullImage ? '' : 'aspect-[7/5]'}`,
    right:
      'w-full shrink-0 lg:w-cols-6 h-fit rounded-sm ' +
      `${props.data?.containFullImage ? '' : 'aspect-[7/5]'}`,
    center: 'w-full lg:w-cols-6 lg:mx-auto shrink-0 h-fit rounded-sm',
  }
})

const placement = computed(() => {
  const articlePlacement = props.data.placement == 'full' ? props.data.placement : 'center'
  return props.data.isArticle ? articlePlacement : props.data.placement
})
provide('showMediaCaption', true)
</script>

<template>
  <div class="relative">
    <div class="background flex" :class="placementWrapperStyles[placement]">
      <div
        v-if="placement !== 'full' && placement !== 'center'"
        class="empty-space lg:w-cols-6 hidden w-full lg:block"
      />
      <div class="media-wrapper overflow-clip" :class="placementMediaStyles[placement]">
        <CommonMedia
          :media="data?.media"
          class="h-full w-auto object-cover"
          :show-video-controls="data?.showVideoControls"
          :rounded="true"
          :sizes="'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw'"
        />
      </div>
    </div>
  </div>
</template>
